module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [_c('p', [_vm._v("Leerlingen kunnen zich aanmelden bij deze klas door de volgende "), _c('strong', [_vm._v("uitnodigingscode")]), _vm._v(" in te voeren op "), _c('a', {
    attrs: {
      "href": '//' + _vm.registerLink
    }
  }, [_vm._v(_vm._s(_vm.registerLink))]), _vm._v(":")]), _c('h1', {
    staticClass: "invite-code"
  }, [_vm._v(_vm._s(_vm.group.code))]), _vm._m(0), _vm._m(1), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom",
      value: ('modal__footer'),
      expression: "'modal__footer'"
    }],
    staticClass: "action-wrapper"
  }, [_c('a', {
    staticClass: "tag button-timid button-forward",
    attrs: {
      "href": _vm.inviteUrl
    }
  }, [_vm._v("Voorbeeld uitnodigingsmail")]), (_vm.isCreating) ? _c('primary-button', {
    on: {
      "clicked": _vm.done
    }
  }, [_vm._v("Klaar")]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('p', {
    staticClass: "note note--info"
  }, [_c('strong', [_vm._v("Let op:")]), _vm._v(" deze code is hoofdlettergevoelig.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('p', {
    staticClass: "note note--info"
  }, [_vm._v("Wijs de leerlingen erop dat ze hun "), _c('strong', [_vm._v("e-mailadres goed invullen")]), _vm._v(", anders kunnen ze zich niet registreren!")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-487df52b","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/groups/settings/Invite.vue
// module id = h1Gv
// module chunks = 0 1